import { MessageSquareWarning } from 'lucide-react';

import { SidebarItem } from './SidebarItem';
import { SidebarSection } from './SidebarSection';

export function ObservabilitySidebar() {
  return (
    <SidebarSection title="Additional Functionality">
      <SidebarItem
        label="Alerting"
        to={'portainer.alerting.index'}
        includePaths={['portainer.alerting.rule']}
        icon={MessageSquareWarning}
        data-cy="portainerSidebar-alerting"
      />
    </SidebarSection>
  );
}
